import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { UpdateCustomerForm } from '@/components/pages/Customer/Update'
import { UpdateCustomerFormValue } from '@/components/pages/Customer/Update/Form'
import UpdateCustomerPageHeader from '@/components/pages/Customer/Update/PageHeader'
import { useWashingMethods } from '@/pages/WashMethods/WashingMethod.hooks'
import { Customer } from '@/types'

import { useCustomers } from '../Customers.hooks'
import { useGetCustomer, useUpdateCustomers } from './update.hooks'

const UpdateCustomer = () => {
  const params = useParams<{ id: string }>()
  const { updateCustomer, loading: updateLoading } = useUpdateCustomers()
  const { getCustomer, loading: getLoading, response: getCustomerResponse } = useGetCustomer()
  const { deleteCustomer } = useCustomers()
  const { getAllWashingMethods, washingMethods } = useWashingMethods()

  const customerId = Number(params.id)

  const handleDeleteCustomer = async (id: Customer['id']) => {
    await deleteCustomer({ id })
  }

  const handleSubmitForm = async (formValues: UpdateCustomerFormValue) => {
    await updateCustomer({
      ...formValues,
      id: customerId,
    })
  }

  useEffect(() => {
    getCustomer({ id: customerId })
    getAllWashingMethods()
  }, [customerId, getCustomer, getAllWashingMethods, params.id])

  return (
    <>
      <UpdateCustomerPageHeader />
      <UpdateCustomerForm
        {...{ updateLoading, getLoading, getCustomerResponse, washingMethods, customerId }}
        onSubmit={handleSubmitForm}
        onDelete={handleDeleteCustomer}
      />
    </>
  )
}

UpdateCustomer.displayName = 'UpdateCustomer'
export default UpdateCustomer
